import joi from 'joi';
import _ from 'lodash';

export function getValues (obj) {
    let values = obj.toJS();
    if (typeof obj.getComputedValues === 'function') {
        Object.assign(values, obj.getComputedValues());
    }
    return values;
}

function cleanErrorMessage (message) {
    // Joi adds "someFieldName" at the start - we strip it out
    return _.isString(message) ? message.replace(/^"[\S]+"\s/, '') : message;
}

const ValidationMixin = {
    isComplete () {
        const schemaData = getValues(this);
        return !this.validateData(schemaData, this.getSchema());
    },

    isFieldValid (field, additionalValues, additionalSchemaFields) {
        const { error } = this.validateField(field, additionalValues, additionalSchemaFields); // you may want to override the stored value to check an arbitrary value against the field's schema

         return error === null;
    },

    validate () {
        return joi.validate(getValues(this), this.getSchema(), { abortEarly: false });
    },

    validateField (field, additionalValues = {}, additionalSchemaFields = []) {
        const values = this.toJS();

        if (values && typeof values[field] !== 'undefined') {
            const schema = Object.assign(...[field, ...additionalSchemaFields].map(name => ({ [name]: this.getSchema()[name] })));

            return joi.validate({
                [field]: values[field],
                ...additionalValues
            }, schema);
        } else {
            throw `The validateField failed because "${field}" does not exist in the Record: ${JSON.stringify(values, null, 2)}.`;
        }
    },

    getValidationSummary () {
        const values = getValues(this);
        const fields = _.zipObject(_.keys(values));
        const errors = this.validateData(values, this.getSchema(), { abortEarly: false });
        const errorDetails = errors ? errors.details : [];

        return errorDetails.reduce((acc, detail) => {
            acc[detail.path] = cleanErrorMessage(detail.message);
            return acc;
        }, fields);
    },

    getValidationSummaryArray () {
        return _.compact(_.values(this.getValidationSummary()));
    },

    getError (field) {
        return this.getValidationSummary()[field];
    },

    validateData (value, schema, options) {
        options = Object.assign({ allowUnknown: true }, options);
        const { error } = joi.validate(value, schema, options);
        return error;
    }
};

export default ValidationMixin;



// WEBPACK FOOTER //
// ./src/records/ValidationMixin.js